import React from 'react';
import { useThemes } from '@core/hooks';

interface FormInputsProps {
  setLogin: React.Dispatch<React.SetStateAction<string>>;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
}

const FormInputs = ({ setLogin, setPassword }: FormInputsProps) => {
  const { isDark } = useThemes();

  return (
    <>
      <div className="login-form-inputs-box">
        <i
          className={`dx-icon-user login-form-inputs-box__icon ${
            !isDark ? 'dx-icon-user login-form-inputs-box__icon--white' : ''
          }`}
        />
        <input
          onChange={(e) => setLogin(e.target.value)}
          type="text"
          className={`login-form-inputs-box__input-field ${
            !isDark ? 'login-form-inputs-box__input-field--white' : ''
          }`}
        />
      </div>
      <div className="login-form-inputs-box mb">
        <i
          className={`dx-icon-key login-form-inputs-box__icon ${
            !isDark ? 'dx-icon-key login-form-inputs-box__icon--white' : ''
          }`}
        />
        <input
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          className={`login-form-inputs-box__input-field ${
            !isDark ? 'login-form-inputs-box__input-field--white' : ''
          }`}
        />
      </div>
    </>
  );
};

export default FormInputs;
